import React, { Component } from 'react'
import { API_LIMIT, contentMaster, isModuleExist, START_PAGE, MODULE_ID_MAP } from '../../utils/Constant';
import { getAllTagretedContentFiltersKeywordApi } from './Api';
import { connect } from 'react-redux';
import { ComponentHeader, InformationModal, VerifiedModal } from '../common';
import TargetedContentForm from './TargetedContentForm';
import { Col, Image, Row } from 'react-bootstrap';
import FilterVefiedDropDown from '../common/FilterVefiedDropDown';
import CustomTable from '../../utils/commonComponent/CustomAntTable';
import editPencil from "../../assets/images/edit-icon.png";
import editIcon from '../../assets/images/edit-icon.svg'
import TargetedKeywordsForm from './TargetedKeywordsForm';
import { withRouter } from '../../utils/hoc/withRouter';
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";

export class TargetedKeywordsTab extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.ContentMasterTargetedContentList);
    this.state = {
      access: AccesData,
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
      isVerify: false,
      show: false,
      verified: '',
      verifyUrl: ''
    };
  }

  componentDidMount() {
    this.props.getAllTagretedContentFiltersKeywordApi(this);
  }


  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData
    });
  };

  render() {
    const { showEdit, access } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;
    return (
      <section className="request-section">

        {/* {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.targetedContentName} ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )} */}
        {/* <VerifiedModal
          name={`'${this.state.editData?.targetedContentName}'`}
          show={this.state.show}
          url={TARGETED_CONTENT_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getTargetedContentApi(this) }}
        /> */}
        {
          showEdit &&
          <TargetedKeywordsForm
            show={showEdit}
            onHide={this.showEditModal}
            editData={this.state.editData}
            this={this}
            ctx={this}
          />
        }
        <ComponentHeader
          title="Targeted Content Keywords"
          isSearch={false}
        />
        <Row>
          <Col sm={2}>
            <FilterVefiedDropDown ctx={this} />
          </Col>
        </Row>
        <div className="commom-table-wrapper">
          <CustomTable
            data={(listData?.list || []).filter(row => !row.isTargetedContent)}
            columns={[
              {
                width: 250,
                title: "Title",
                dataIndex: "title",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  return rowData.title;
                },
              },

              {
                width: 150,
                title: "Updated By",
                dataIndex: "updatedBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  return rowData?.updatedBy?.name || 'Na';
                },
              },
              {
                width: 150,
                title: "Created By",
                dataIndex: "createdBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  return rowData?.createdBy?.name || 'Na';
                },
              },
              {
                width: 20,
                title: "Action",
                dataIndex: "",
                className: "",
                fixed: 'right',
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return (
                      <OptionsDropdown
                        editHandler={access?.updateAccess ? () => { this.showEditModal(rowData) } : null}  
                        deleteHandler={null}
                      />
                    );
                },
              },
            ]}
            message="No data found"
            history={this.props.history}
            location={this.props.location}
            total={totalPages}
            currentPage={currentPage}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getAllTagretedContentFiltersKeywordApi
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TargetedKeywordsTab));
